<template>
  <div>
    <!-- 検索フォーム -->
    <div class="row mb-3">
      <div class="col-2 mb-2">
        <p class="text-center py-1 fs-6">年度</p>
      </div>
      <div class="col-3 mb-2">
        <div class="input-group">
          <bs-select
            :options="yearOptions"
            :modelValue="selectedYear"
            @update:modelValue="$emit('update:selectedYear', $event)"
            :null-option="true"
            :classParam="'form-select'"
          ></bs-select>
        </div>
      </div>
      <div class="col-2 mb-2">
        <p class="text-center py-1 fs-6">マスタ項目</p>
      </div>
      <div class="col-3 mb-2">
        <div class="input-group">
          <bs-select
            :options="masterTypeOptions"
            :modelValue="selectedMasterType"
            @update:modelValue="$emit('update:selectedMasterType', $event)"
            :null-option="true"
            :classParam="'form-select'"
          ></bs-select>
        </div>
      </div>
    </div>

    <!-- 検索ボタン -->
    <div class="row">
      <div class="col text-center"></div>
      <div class="col text-center">
        <button
          class="btn btn-primary btn-sm"
          :disabled="loading"
          @click="$emit('search')"
        >
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm me-2"
            role="status"
          ></span>
          検索
        </button>
      </div>
      <div class="col text-end">
        <button
          class="btn btn-light btn-outline-secondary btn-sm"
          :disabled="loading"
          @click="$emit('clear')"
        >
          検索条件クリア
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BsSelect from '../../../atoms/BsSelect.vue'

export default {
  name: 'MasterSearchForm',
  components: {
    BsSelect
  },
  props: {
    yearOptions: {
      type: Array,
      required: true
    },
    masterTypeOptions: {
      type: Array,
      required: true
    },
    selectedYear: {
      type: String,
      required: true
    },
    selectedMasterType: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:selectedYear', 'update:selectedMasterType', 'search', 'clear']
}
</script>

<style scoped>
.btn-light.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-light.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

/* ボタンサイズの統一 */
.btn {
  min-width: 100px;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  border-radius: 0.2rem;
  transition: all 0.15s ease-in-out;
}

/* ローディング時のスタイル調整 */
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* リロード後のスタイルリセット */
.btn:not(:disabled) {
  opacity: 1;
  cursor: pointer;
}

/* スピナーのサイズ調整 */
.spinner-border-sm {
  width: 0.875rem;
  height: 0.875rem;
}
</style>
